import { render, staticRenderFns } from "./DoctorRestrictionsBanner.vue?vue&type=template&id=44f365c5&scoped=true&"
import script from "./DoctorRestrictionsBanner.vue?vue&type=script&lang=ts&setup=true&"
export * from "./DoctorRestrictionsBanner.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./DoctorRestrictionsBanner.vue?vue&type=style&index=0&id=44f365c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f365c5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44f365c5')) {
      api.createRecord('44f365c5', component.options)
    } else {
      api.reload('44f365c5', component.options)
    }
    module.hot.accept("./DoctorRestrictionsBanner.vue?vue&type=template&id=44f365c5&scoped=true&", function () {
      api.rerender('44f365c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuDoctorsList/components/DoctorRestrictionsBanner.vue"
export default component.exports